<template>
  <div v-r-loading="cardLoading" class="card">
    <div class="card-content">
      <CardList />
      <!-- <AddCard @update="updateList" /> -->
    </div>
    <!-- 现金支付 -->
    <Cash />
    <!-- didicash支付 -->
    <DidiCash />
    <!-- paypay -->
    <!-- <PayPay /> -->
    <!-- pos支付 -->
    <!-- <Pos /> -->
  </div>
</template>

<script>
import CardList from './cardList.vue'
// import AddCard from './addCard.vue';
import Cash from './cash.vue'
// import PayPay from './paypay.vue';
import DidiCash from './didicash.vue'
import { mapState } from 'vuex'
// import { PAY_CHANNEL_TYPE } from '@/const/paymentProcess';

// import Pos from './pos.vue';
export default {
  name: 'CardContent',
  components: {
    CardList,
    Cash,
    DidiCash,
    // PayPay,
    // Pos,
  },
  data() {
    return {
      selectedMent: {},
    }
  },
  computed: {
    ...mapState({
      cardLoading: ({ pay }) => pay.cardLoading,
    }),
  },
  methods: {
    updateList() {
      this.$emit('update')
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  height: 504px;
  overflow: auto;
  padding-top: 10px;
  .card-content {
    width: 422px;
    padding-left: 20px;
    background: #fff;
    border-radius: 8px;
    margin: 0 auto;
  }
}
@media screen and (max-width: 768px) {
  .card {
    height: calc(92vh - 200px);
    padding-bottom: 200px;
    .card-content {
      width: rem(702);
      padding-left: rem(20);
      border-radius: rem(12);
    }
  }
}
</style>
